// NOTE: SafariがUA-CHに対応していないので、UAでChrome以外かどうか判定する.
export function isNotChrome(): boolean {
  const userAgent = window.navigator.userAgent.toLowerCase() as string;
  return userAgent.indexOf("chrome") == -1;
}
